import {
  ESIM_UPSELL_TICKET_METADATA,
  type LoyaltyEsimUpsellTicketMetadata,
} from 'loyalty/constants/loyaltyEsimUpsellOptions'
import { getEsimUpsellTicketIdsFromTicket } from 'loyalty/lib/esims/esimUpsellTicketUtils'

function getIsUnavailableFromCurrentPackage(
  candidate: LoyaltyEsimUpsellTicketMetadata,
  current: LoyaltyEsimUpsellTicketMetadata,
): boolean {
  if (candidate.kind === 'gb_pack' && current.kind === 'unlimited_days') {
    return true
  }

  if (candidate.kind === 'gb_pack' && current.kind === 'gb_pack') {
    return candidate.gb <= current.gb
  }

  if (candidate.kind === 'unlimited_days' && current.kind === 'unlimited_days') {
    return candidate.days <= current.days
  }

  return false
}

/**
 * Defensive filter to exclude downgrades and unsupported ticket ids.
 */
export function buildEsimUpsellPurchasableTickets(
  catalog: App.LoyaltyEsimUpsellCatalog,
  currentPackageTicketId?: App.LoyaltyEsimUpsellTicketId | null,
): Array<App.LoyaltyEsimUpsellCatalogTicket> {
  const currentPackage = currentPackageTicketId
    ? ESIM_UPSELL_TICKET_METADATA[currentPackageTicketId]
    : null

  return catalog.tickets.filter((ticket) => {
    const { toTicketId: ticketId } = getEsimUpsellTicketIdsFromTicket(ticket)
    if (!ticketId) return false

    const upgrade = ESIM_UPSELL_TICKET_METADATA[ticketId]
    if (currentPackage && getIsUnavailableFromCurrentPackage(upgrade, currentPackage)) {
      return false
    }

    return true
  })
}
